import classnames from 'classnames';
import { forwardRef, PropsWithChildren, ReactNode } from 'react';

type Props = {
  className?: string;
  fullWidth?: boolean;
};

const PageSection = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, className, fullWidth = false }, ref) => {
    return (
      <div
        ref={ref}
        className={classnames(
          'relative w-full',
          {
            'wrapper-website': !fullWidth,
          },
          className,
        )}
      >
        {children}
      </div>
    );
  },
);

export default PageSection;
